import { render } from "./FoerderorgAnsprechpartnerModalMirZuweisen.pug?vue&type=template&id=6778bbd3&lang=pug"
import script from "./FoerderorgAnsprechpartnerModalMirZuweisen.js?vue&type=script&lang=js"
export * from "./FoerderorgAnsprechpartnerModalMirZuweisen.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__